import * as React from "react";


export default class Impressum extends React.Component{
    render(){
        return(
            <div>
                <div className="header_Team">
                    <div className="header_openHours_text">Impressum</div>
                </div>
                <div className="impressumContainer">
                    <div className="paragraphModal">
                        <ul className="listpadding">
                            <li className="list-unstyled">
                                <h5 className="title">Kontakt</h5>
                            </li>
                            <li className="list-unstyled">
                                <h6>RuS Mehele GmbH</h6>
                            </li>
                            <li className="list-unstyled">
                                Radetzkystraße 132
                            </li>
                            <li className="list-unstyled">
                                A- 6845 Hohenems
                            </li>
                            <li className="list-unstyled">
                                Tel.: +43-5576-72397-71
                            </li>
                            <li className="list-unstyled">
                                Mail: rainer.mehele@mehele.at
                            </li>
                        </ul>
                    </div>
                    <div className="paragraphModal">
                        <ul className="listpadding">
                            <li className="list-unstyled">
                                <span className="boldPrint_Impressum">Unternehmensgegenstand:</span> Einzelhandel und Reparatur von Landmaschinen
                            </li>
                            <li className="list-unstyled">
                                <span className="boldPrint_Impressum">UID-Nummer:</span> ATU57732911
                            </li>
                            <li className="list-unstyled">
                                <span className="boldPrint_Impressum">Firmenbuchnummer:</span> 245036y
                            </li>
                            <li className="list-unstyled">
                                <span className="boldPrint_Impressum">Firmenbuchgericht:</span> Feldkirch
                            </li>
                            <li className="list-unstyled">
                                <span className="boldPrint_Impressum">Firmensitz:</span> 6845 Hohenems
                            </li>
                        </ul>
                    </div>
                    <div className="paragraphModal">
                        Wir entwickeln die Inhalte dieser Webseite ständig weiter und bemühen uns korrekte und aktuelle Informationen bereitzustellen. Leider können wir keine Haftung für die Korrektheit aller Inhalte auf dieser Webseite übernehmen, speziell für jene die seitens Dritter bereitgestellt wird. Sollten Ihnen problematische oder rechtswidrige Inhalte auffallen, bitte wir Sie uns umgehend zu kontaktieren, Sie finden die Kontaktdaten im Impressum.
                    </div>
                    <div className="paragraphModal">
                        Unsere Webseite enthält Links zu anderen Webseiten für deren Inhalt wir nicht verantwortlich sind. Wenn Ihnen rechtswidrige Links auf unserer Webseite auffallen, bitte wir Sie uns zu kontaktieren, Sie finden die Kontaktdaten im Impressum.
                    </div>
                    <div className="paragraphModal">
                        Alle Inhalte dieser Webseite (Bilder, Fotos, Texte, Videos) unterliegen dem Urheberrecht. Falls notwendig, werden wir die unerlaubte Nutzung von Teilen der Inhalte unserer Seite rechtlich verfolgen.
                    </div>
                    <div className="paragraphModal">
                        Diese Website benutzt Google Analytics, einen Webanalysedienst der Google Inc. („Google“) Google Analytics verwendet sog. „Cookies“, Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Website durch Sie ermöglicht. Die durch den Cookie erzeugten Informationen über Ihre Benutzung diese Website (einschließlich Ihrer IP-Adresse) wird an einen Server von Google in den USA übertragen und dort gespeichert. Google wird diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um Reports über die Websiteaktivitäten für die Websitebetreiber zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen zu erbringen.

                        Auch wird Google diese Informationen gegebenenfalls an Dritte übertragen, sofern dies gesetzlich vorgeschrieben oder soweit Dritte diese Daten im Auftrag von Google verarbeiten. Google wird in keinem Fall Ihre IP-Adresse mit anderen Daten der Google in Verbindung bringen. Sie können die Installation der Cookies durch eine entsprechende Einstellung Ihrer Browser Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht sämtliche Funktionen dieser Website voll umfänglich nutzen können. Durch die Nutzung dieser Website erklären Sie sich mit der Bearbeitung der über Sie erhobenen Daten durch Google in der zuvor beschriebenen Art und Weise und zu dem zuvor benannten Zweck einverstanden.
                    </div>



                </div>
            </div>
        );
    }
};